import React from 'react';
import {connect} from 'react-redux';

// external
import {sortBy, get} from 'lodash';


// local imports
import api from '../../../store/api'
import {pullStates} from '../../../store/calls'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import validators from "../../../utils/forms/validators";

import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import * as actions from "../../../store/actions";
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert} from "../../../store/calls/alertLoadingDispatch";
import SearchAndSelectModal from "../../theme/modals/SearchAndSelectModal";
import ItemTextEditModal from "../../theme/modals/ItemTextEditModal";




class DistrictAdminScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editModalOpen: false,
            exceptionModalOpen: false,
            displayedDistricts: [],
            displayedPacePrograms: [],
            dataPullLimit: 100,
            dataPullOffset: 0,

            // filters
            nameFilter: null,
            typeFilter: null,
            stateFilter: null,

            editingInstance: {},
        };


        this.createDistrictInputs = [
            {
                type: 'text',
                label: "Name",
                dataKey: "name",
                placeholder: "District Name",
                ...validators.isStringOfMinLength(2)
            },
            {
                type: 'text',
                label: "County",
                dataKey: "county",
                placeholder: "county",
                ...validators.exists
            }
        ]
    }

    componentDidMount() {

        toggleGlobalLoader(true);

        Promise.all([
            this.getData(),
            pullStates()
        ])
            .then(() => this.getPacePrograms())
            .then(() => toggleGlobalLoader(false))
            .catch(() => {
                toggleGlobalLoader(false)
                addErrorAlert('Failed to load all initial data.', 10 * 1000)
            })

    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }

    addProgramListStringToDistrict = (district) => ({
        ...district,
        program_list: district.pace_programs.reduce((r, p) => {
            return `${r}${r.length ? ',' : ''} ${p.pace_program.name}`
        }, '')
    })

    getEditingInstanceById = (id) => {
        return {...this.state.displayedDistricts.find(d => d.id === id) || {}}
    }

    addExceptionStringToDistrict = (district) => {


        // so i can make changes and data will update, pull from displayed district if available
        let displayedDistrict = this.state.displayedDistricts.find(d => d.id === district.id) || district;
        let exceptions = get(displayedDistrict, 'exceptions', []);

        return {
            ...district,
            _html_exceptions: (
                <div>
                    <span
                        className="mr-3 icon has-text-primary"
                        onClick={() => {
                            this.setState({exceptionModalOpen: true, editingInstance: this.getEditingInstanceById(district.id)})
                        }}
                    >
                        <i className="far fa-edit"/></span>
                    {exceptions.length ?
                        <span className="has-text-primary has-text-weight-semibold">{exceptions.length}</span> :
                        <span className="has-text-grey-lighter">--</span>}
                </div>
            )

        }
    }




    getData = (xtraParams = {}) => {
        let params = {limit: this.state.dataPullLimit, offset: this.state.dataPullOffset, ...xtraParams}

        if (this.state.stateFilter) params.state = this.state.stateFilter;
        if (this.state.typeFilter) params.type = this.state.typeFilter;
        if (this.state.nameFilter) params.name = this.state.nameFilter;
        // if (this.state.state)

        return api.get('/districts/', params)
            .then(res => {
                let results = res.data.results || [];
                results = results
                    .map(this.addProgramListStringToDistrict)
                    .map(this.addExceptionStringToDistrict);
                this.setState({displayedDistricts: results})
            })
    }

    getPacePrograms = (xtraParams = {}, loader = true) => {
        let params = {
            limit: 100,
            offset: 0,
            ...xtraParams
        }

        if (loader) toggleGlobalLoader(true);

        api.get('/pace-programs/', params)
            .then(res => {

                let results = res.data.results || [];
                results = sortBy(results, ['name'])
                this.setState({displayedPacePrograms: results})
            })
            .catch(() => {
                addErrorAlert('Failed to get pace program data.');
            })
            .finally(() => {
                toggleGlobalLoader(false);
            })
    }

    handleDistrictPaceProgramDeleteRequest = (id, pace_program_id) => {
        let district_id = this.state.editingInstance.id;
        api.delete('/district-pace-programs/' + id)
            .then((res) =>
                this.setState({
                    editingInstance: {
                        ...this.state.editingInstance,
                        pace_programs: this.state.editingInstance.pace_programs.filter(p => p.id !== id)
                    }
                }))
            .catch(() => addErrorAlert('Failed to delete the district pace program.'));
    }

    handleDistrictPaceProgramCreateRequest = (pace_program) => {
        let district_id = this.state.editingInstance.id;
        api.post('/district-pace-programs/', {district: district_id, pace_program: pace_program.id})
            .then((res) =>
                this.setState({
                editingInstance: {
                    ...this.state.editingInstance,
                    pace_programs: [...this.state.editingInstance.pace_programs, {id: res.data.id, pace_program}]
                }
            }))
            .catch(() => addErrorAlert('Failed to create the district pace program.'));
    }

    handleDistrictPaceProgramPatchRequest = (dpp_id, data) => {
        let district_id = this.state.editingInstance.id;
        api.patch(`/district-pace-programs/${dpp_id}/`, {...data})
            .then((res) =>
                this.setState({
                    editingInstance: {
                        ...this.state.editingInstance,
                        pace_programs: this.state.editingInstance.pace_programs
                            .map(p => p.id === dpp_id ? {...p, ...data} : p)
                    }
                }))
            .catch(() => addErrorAlert('Failed to update the district pace program.'));

    }


    renderPaceProgramSearchAndSelectElement = (result) => {
        // where result is a serialized pace program
        result.selected = false;
        result.districtpaceprogram = null;
        if (this.state.editingInstance.pace_programs) {
            // map out ids to see if it contains the results
            let dpp_obj = this.state.editingInstance.pace_programs.find(d => d.pace_program.id === result.id)
            if (dpp_obj) {
                result.selected = true;
                result.districtpaceprogram = dpp_obj;
            }
        }

        return (
            <div className="ss-result"
                 style={{cursor: "pointer"}}
                 onClick={() => {
                     if (result.selected) {
                         let dpp_id = (this.state.editingInstance.pace_programs.find(d => d.pace_program.id === result.id) || {}).id;
                         if (!dpp_id) return;
                         this.handleDistrictPaceProgramDeleteRequest(dpp_id, result.id);
                     } else {
                         this.handleDistrictPaceProgramCreateRequest(result);
                     }
                 }}
            >
            <span
                className="icon"
            >
                {result.selected ?
                    <i className="fas fa-check-square has-text-success"/> :
                    <i className="far fa-square"/>}
            </span>
                <span className="has-text-weight-semibold">{result.name}</span>
                {this.state.editingInstance.district_type === 'County' && !!result.districtpaceprogram &&
                    <span
                        style={{cursor: 'pointer'}}
                        onClick={() => {
                            this.handleDistrictPaceProgramPatchRequest(
                                result.districtpaceprogram.id,
                                {all_child_districts_included: !result.districtpaceprogram.all_child_districts_included}
                            )
                        }}
                    >
                        <span className={`is-size-6 mr-4 ${result.districtpaceprogram.all_child_districts_included ? 'has-text-success' : 'has-text-grey'}`}>
                            {result.districtpaceprogram.all_child_districts_included ? 'All Cities Included' : 'Include All Cities'}
                        </span>
                        <span className="icon">
                            <i className={`fas fa-vector-square ${result.districtpaceprogram.all_child_districts_included ? 'has-text-success' : 'has-text-grey-lighter'}`}/>
                        </span>
                    </span>
                }
            </div>
        )
    }

    reinsertEditedDistrict = () => {
        this.setState({displayedDistricts: this.state.displayedDistricts
                                .map(d => d.id === this.state.editingInstance.id ?
                                    {...this.addProgramListStringToDistrict(this.state.editingInstance)} :
                                    d),
                            editingInstance: {},
        })
    }



    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.getData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.getData)
    }

    buildFilterOptions = () => {
        let options = sortBy(this.props.states, ['name']).map(d => ({value: d.id, display: d.name}));
        options.unshift({value: 0, display: 'All States'})
        return [
            {
                options,
                value: this.state.stateFilter, // default ca
                onChange: (val) => this.setState({stateFilter: val}, this.getData)
            }
        ]
    }

    handleSearch = (val) => {
        this.setState({
            nameFilter: val
        }, this.getData)
    }

    handleExceptionAdditionOrEdit = (val, exception_id = 0) => {
        let promise;
        if (exception_id) {
            promise = () => api.patch(`/district-exceptions/${exception_id}/`, {
                text_value: val
            })
        } else {
            promise = () => api.post('/district-exceptions/',{
                district: this.state.editingInstance.id,
                text_value: val
            })
        }

        toggleGlobalLoader(true);
        promise()
            .then((res) => {
                this.setState({
                    displayedDistricts: this.state.displayedDistricts.map(d => {
                        if (d.id === this.state.editingInstance.id) {
                            return {...d, exceptions: [...d.exceptions, res.data]}
                        } 
                            return d
                        
                    }).map(this.addExceptionStringToDistrict)
                }, () => this.setState({editingInstance: this.state.displayedDistricts.find(d => d.id === this.state.editingInstance.id)}))

            })
            .catch(() => {
                addErrorAlert(`The exception failed to ${exception_id ? 'update' : 'create'}.`)
            })
            .finally(() => toggleGlobalLoader(false))
    }


    handleExceptionDeletion = (exception_id) => {
        toggleGlobalLoader(true);

        api.delete(`/district-exceptions/${exception_id}/`)
            .then((res) => {
                this.setState({
                    displayedDistricts: this.state.displayedDistricts.map(d => {
                        if (d.id === this.state.editingInstance.id) {
                            return {...d, exceptions: [...d.exceptions.filter(e => e.id !== exception_id)].map(this.addExceptionStringToDistrict)}
                        } 
                            return d
                        
                    })
                }, () => this.setState({editingInstance: this.state.displayedDistricts.find(d => d.id === this.state.editingInstance.id)}))

            })
            .catch(() => {
                addErrorAlert('The exception failed to delete.')
            })
            .finally(() => toggleGlobalLoader(false))
    }



    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        {/* They are called Districts in code, but PH hated that word, so changed it to communities here. */}
                        <h2 className="title is-2">Manage Communities</h2>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            data={this.state.displayedDistricts}
                            columns={['name', 'district_type', 'program_list', 'exceptions', 'state']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            filterOptions={this.buildFilterOptions()}
                            handleSearch={this.handleSearch}
                            actions={[
                                {
                                    name: 'Edit',
                                    elem: (<span className="icon has-text-info">
                                                <b>+</b><i className="fas fa-map-marked-alt" alt="add pace program"/>
                                            </span>),
                                    action: (data) => this.setState({editModalOpen: true, editingInstance: data})
                                },
                            ]}
                            // onRowClick={(data) => this.setState({editModalOpen: true, editingInstance: data})}
                        />

                    </div>
                </div>


                {/*  Search for an add districts to pace program  */}
                <SearchAndSelectModal
                    title={`Add ${this.state.editingInstance.name} ${this.state.editingInstance.district_type} to Pace Programs`}
                    visible={this.state.editModalOpen}
                    onCancel={() => {
                        this.setState({editModalOpen: false})
                        this.reinsertEditedDistrict();
                    }}
                    handleSearch={(val) => {
                        if (val.length > 2) {
                            this.getPacePrograms({searchVal: val});
                        }
                    }}
                    results={this.state.displayedPacePrograms.filter(d => d.state === this.state.editingInstance.state)}
                    renderResultElement={this.renderPaceProgramSearchAndSelectElement}
                />

                <ItemTextEditModal
                    visible={this.state.exceptionModalOpen}
                    title={'Edit Exceptions for ' + this.state.editingInstance.name}
                    onCancel={() => this.setState({exceptionModalOpen: false})}
                    items={this.state.editingInstance.exceptions || []}
                    onAdd={(val) => this.handleExceptionAdditionOrEdit(val)}
                    onDelete={this.handleExceptionDeletion}
                />

            </AdminWrapper>
        )
    }

}

const mapStateToProps = state => ({
    states: state.states.data
})


const mapDispatchToProps = dispatch => ({
    removeAlert: alert_id => dispatch(actions.alerts.removeAlert(alert_id)),
    clearAllAlerts: () => dispatch(actions.alerts.clearAllAlerts()),
    addAlert: alert_data => dispatch(actions.alerts.addAlert(alert_data)),
});


export default connect(mapStateToProps, mapDispatchToProps)(DistrictAdminScreen)
